/**
 * Single source for building `?redirect_url=` auth links (#1774).
 *
 * Deliberately a neutral, non-"use client" module: server components (the
 * login page's `signUpUrl`, the team-join redirect) and client components
 * (AuthStepGuard, AttributedSignUp, checkout) all build the same shape, and
 * the client-marked guard module can't be imported from a server component.
 *
 * Callers are responsible for the target being a SAFE INTERNAL path
 * (firstSafeAuthRedirect / safeInternalPath) — this helper only encodes.
 */
export function withRedirectUrl(
  basePath: string,
  redirectTarget: string | null | undefined,
): string {
  return redirectTarget
    ? `${basePath}?redirect_url=${encodeURIComponent(redirectTarget)}`
    : basePath;
}
